import { useQuery } from "@tanstack/react-query";
import { useApi } from "./api-context.js";
import { requireData } from "./api-error.js";
export const marketDataSelectionKey = ["market-data", "selection"] as const;
export function useMarketDataSelection() {
  const api = useApi();
  return useQuery({
    queryKey: marketDataSelectionKey,
    queryFn: async ({ signal }) => requireData(await api.GET("/market-data-settings", { signal })),
    staleTime: 30_000,
  });
}
